<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <div class="content-wrap">
      <img src="../assets/images/xiaochengxu-erweima.jpg" class="imgs">
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>

.content-wrap::before{
    position:absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index:-100;
}
.content-wrap {
  width: 100%;
  margin: 0 auto;
}

.imgs {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/schoolAlumni.vue